import { render } from "./resume_detail.vue?vue&type=template&id=24b7ab6c&scoped=true"
import script from "./resume_detail.vue?vue&type=script&lang=js"
export * from "./resume_detail.vue?vue&type=script&lang=js"

import "./resume_detail.vue?vue&type=style&index=0&id=24b7ab6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b7ab6c"]])

export default __exports__